<template>
    <Timeline :value="completeTicketHistory" align="left">
        <template #marker="slotProps">
            <span class="custom-marker" :class="[slotProps.item.type == 'statusUpdate' ? 'update-icon':'comment-icon' ]" >
                <i :class="[slotProps.item.type == 'statusUpdate' ? 'pi pi-cog':'pi pi-comments' ]"></i>
            </span>
        </template>
        <template #opposite="slotProps">
            <Card v-if="slotProps.item.isOwnerContent">
                <template #title>
                    {{slotProps.item.owner}}
                </template>
                <template #subtitle>
                    {{slotProps.item.date}}
                </template>
                <template #content>
                    {{slotProps.item.description}}
                </template>
            </Card>
        </template>
        <template #content="slotProps" >
            <Card v-if="!slotProps.item.isOwnerContent">
                <template #title>
                    {{slotProps.item.owner}}
                </template>
                <template #subtitle>
                    {{slotProps.item.date}}
                </template>
                <template #content>
                    {{slotProps.item.description}}
                </template>
            </Card>
        </template>
    </Timeline>
</template>
<script>
export default {
    data(){
        return{
            statusUpdateDescriptionNew: this.$t("tickets.statusUpdateDescriptionNew"),
            statusUpdateDescriptionOpen: this.$t("tickets.statusUpdateDescriptionOpen"),
            statusUpdateDescriptionPending: this.$t("tickets.statusUpdateDescriptionPending"),
            statusUpdateDescriptionClosed: this.$t("tickets.statusUpdateDescriptionClosed"),
        }
    },
    props:{
        history: null,
        comments: null,
        ticketOwnerId:null,
    },
    computed :{
        completeTicketHistory: function(){
            // Combine history and comments to create a full history
            return this.combineHistoryAndComments();
        }
    },
    methods:{
        combineHistoryAndComments(){
            let completeTicketHistory = []; //status updates + comments

            let historyValidStatus = ["ticket:created", "ticket:set:status:1", "ticket:set:status:2", "ticket:set:status:3"]

            this.history.forEach(event=>{
                if(historyValidStatus.includes(event.action)){
                    let eventToAppend = {};
                    eventToAppend.date = new Date(event.date).toLocaleString();
                    eventToAppend.owner = event.owner.fullname;
                    eventToAppend.isOwnerContent= event.owner['_id'] == this.ticketOwnerId ? true : false;
                    switch(event.action){
                        case "ticket:created": {
                            eventToAppend.type="statusUpdate";
                            eventToAppend.description= this.statusUpdateDescriptionNew
                            break;
                        }
                        case "ticket:set:status:1": {
                            eventToAppend.type="statusUpdate";
                            eventToAppend.description= this.statusUpdateDescriptionOpen
                            break;
                        }
                        case "ticket:set:status:2": {
                            eventToAppend.type="statusUpdate";
                            eventToAppend.description= this.statusUpdateDescriptionPending
                            break;
                        }
                        case "ticket:set:status:3": {
                            eventToAppend.type="statusUpdate";
                            eventToAppend.description= this.statusUpdateDescriptionClosed;
                            break;
                        }
                    }
                    completeTicketHistory.push(eventToAppend)
                }
                });
            
            this.comments.forEach(comment => {
                let eventToAppend={};
                eventToAppend.date = new Date(comment.date).toLocaleString();
                eventToAppend.owner = comment.owner.fullname;
                eventToAppend.type = "commentAdded";
                eventToAppend.description = this.parseHtmlDescription(comment.comment);
                eventToAppend.isOwnerContent= comment.owner['_id'] == this.ticketOwnerId ? true : false;
                completeTicketHistory.push(eventToAppend);
            })

            completeTicketHistory= completeTicketHistory.sort(function(a,b){
                return new Date(b.date) - new Date(a.date);
            });

            return completeTicketHistory;            
        },

        parseHtmlDescription(description){
            description = description.replace(/(<([^>]+)>)/g, "\n")
            return description
        },
    }
}
</script>
<style>
    
    .custom-marker {
        display: flex;
        width: 2.5rem;
        height: 2.5rem;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        border-radius: 50%;
        z-index: 1;
       
    }

    .update-icon{
        background-color: #98A6B4
    }

    .comment-icon{
        background-color: #FCB158;
    }

    .p-card .p-card-title {
        font-size: 1rem;
    }

    .p-card .p-card-body{
        padding: 1rem;
    }
    
    .p-timeline-event-opposite{
        margin-bottom: 1rem;
    }
    .p-timeline-event-content{
        margin-bottom: 1rem;
    }
    .p-card {
        display: inline-block;
        word-break: break-all;
    }


</style>